export default __webpack_public_path__ + "static/media/edital 12.2023.SEDEC.SINE.99a9a9d3.pdf";